import styled, {css} from "styled-components"

export const CategoryWrapper = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.half} 0;
    margin-top: ${theme.spacing.one};
  `}
`

export const SelectorWrapper = styled.div`
  ${({theme}) => css`
    display: flex;
    flex-wrap: wrap;
    margin: ${theme.spacing.one} 0;
  `}
`
